export default [
	{
		path: '/mylive/',
		component: () => import('@/views/home'),
		name: 'acitvityManage',
		title: '管理后台',
		type: 'activity',
		status: 1,
		class: 'icon-fanhuihoutai',
		meta: {
			crumb: '管理后台',
			title: '管理后台',
			code: 20,
		},
		children: [
			//全景直播
			{
				path: 'full/:id',
				component: () => import('@/views/user/fullLive'),
				title: '全景直播',
				name: 'mylive.full',
				ename: 'full/',
				class: 'icon-quanjingzhibo',
				isfullFlag: true,
				meta: {
					crumb: '全景直播',
					title: '全景直播',
				},
				children: [
					{
						path: 'stream',
						name: 'mylive.full.stream',
						component: () => import('@/views/user/streamWatch'),
						meta: {
							crumb: '视频直播',
							title: '视频直播',
							parentName: 'mylive.full',
						},
						hidden: true,
					},
				],
			},
			//发布直播
			{
				path: 'video/:id',
				component: () => import('@/views/user/VideoLive'),
				title: '视频直播',
				name: 'mylive.video',
				ename: 'video/',
				class: 'icon-shipinzhibo',
				isFlagship: true,
				meta: {
					crumb: '视频直播',
					title: '视频直播',
				},
				children: [
					{
						path: 'stream',
						name: 'mylive.video.stream',
						component: () => import('@/views/user/streamWatch'),
						hidden: true,
						meta: {
							crumb: '视频直播',
							title: '视频直播',
							parentName: 'mylive.video',
						},
					},
				],
			},
			// 图文直播
			{
				path: 'post/:id',
				component: () => import('@/views/user/newPost'),
				name: 'mylive.post',
				title: '图文直播',
				ename: 'post/',
				class: 'icon-zhibofabu-',
				isGuideHide: true,
				meta: {
					crumb: '图文直播',
					title: '图文直播',
				},
			},
			// 绑定分发平台
			{
				path: 'platform/bind/:id',
				component: () => import('@/views/user/platform/bind'),
				name: 'mylive.platform.bind',
				isFlagship: true,
				hidden: true,
				meta: {
					crumb: '平台分发',
					title: '平台分发',
					parentName: 'mylive.video',
				},
			},
			// 设置快手分发平台
			{
				path: 'platform/ks/:id/:ksId',
				component: () => import('@/views/user/platform/setKs'),
				name: 'mylive.platform.ks',
				isFlagship: true,
				hidden: true,
				meta: {
					crumb: '快手平台',
					title: '快手平台',
					parentName: 'mylive.video',
				},
			},
			// 直播设置
			{
				path: 'liveset/:id',
				component: () => import('@/views/user/liveset'),
				name: 'mylive.liveset',
				title: '直播设置',
				ename: 'liveset/',
				class: 'icon-zhiboshezhi-',
				initName: 'creat',
				init: false,
				initContent: '直播详细设置在这里！',
				redirect: { name: 'liveset_base' },
				line: true,
				meta: {
					crumb: '直播设置',
					title: '直播设置',
				},
				children: [
					{
						path: 'base',
						name: 'liveset_base',
						meta: {
							crumb: '直播设置',
							title: '直播设置',
							name: '基本设置',
							parentName: 'mylive.liveset',
						},
						hidden: true,
						component: () => import('@/views/user/liveset/base'),
					},
					{
						path: 'introduce',
						name: 'liveset_introduce',
						meta: {
							crumb: '直播设置',
							title: '直播设置',
							name: '简介设置',
							parentName: 'mylive.liveset',
						},
						hidden: true,
						component: () => import('@/views/user/liveset/introduce'),
					},
					{
						path: 'func',
						name: 'liveset_func',
						meta: {
							crumb: '直播设置',
							title: '直播设置',
							name: '功能设置',
							parentName: 'mylive.liveset',
						},
						hidden: true,
						component: () => import('@/views/user/liveset/func'),
					},
					{
						path: 'spread',
						name: 'liveset_spread',
						meta: {
							crumb: '直播设置',
							title: '直播设置',
							name: '推广设置',
							parentName: 'mylive.liveset',
						},
						hidden: true,
						component: () => import('@/views/user/liveset/spread'),
						redirect: { name: 'liveset_spread.show' },
						children: [
							{
								path: 'show',
								name: 'liveset_spread.show',
								meta: {
									crumb: '直播设置',
									title: '直播设置',
									typeName: 'liveset_spread',
									parentName: 'mylive.liveset',
								},
								component: () => import('@/views/user/liveset/spread/display'),
								hidden: true,
							},
							{
								path: 'guide',
								name: 'liveset_spread.ad',
								meta: {
									crumb: '直播设置',
									title: '直播设置',
									typeName: 'liveset_spread',
									parentName: 'mylive.liveset',
								},
								component: () => import('@/views/user/liveset/spread/advert'),
								hidden: true,
							},
							{
								path: 'drainage',
								name: 'liveset_spread.drainage',
								meta: {
									crumb: '直播设置',
									title: '直播设置',
									typeName: 'liveset_spread',
									parentName: 'mylive.liveset',
								},
								component: () => import('@/views/user/liveset/spread/drainage'),
								hidden: true,
							},
							{
								path: 'preheat',
								name: 'liveset_spread.preheat',
								meta: {
									crumb: '预热页设置',
									title: '预热页设置',
									typeName: 'liveset_spread',
									parentName: 'mylive.liveset',
								},
								component: () => import('@/views/user/liveset/spread/preheat'),
								hidden: true,
							},
							{
								path: 'preheatStatistics/:preheadId',
								name: 'liveset_spread.preheatStatistics',
								meta: {
									crumb: '直播设置',
									title: '直播设置',
									typeName: 'liveset_spread',
									parentName: 'mylive.liveset',
								},
								component: () => import('@/views/user/liveset/spread/preheatStatistics'),
							},
							{
								path: 'store',
								name: 'liveset_spread.store',
								meta: {
									crumb: '推广门店设置',
									title: '推广门店设置',
									typeName: 'liveset_spread',
									parentName: 'mylive.liveset',
								},
								component: () => import('@/views/user/liveset/spread/store'),
							},
						],
					},
					{
						path: 'advanced',
						name: 'liveset_advanced',
						meta: {
							crumb: '直播设置',
							title: '直播设置',
							name: '高级设置',
							parentName: 'mylive.liveset',
						},
						hidden: true,
						component: () => import('@/views/user/liveset/advanced'),
					},
					{
						path: 'water',
						name: 'liveset_water',
						meta: {
							crumb: '直播设置',
							title: '直播设置',
							name: '水印设置',
							parentName: 'mylive.liveset',
						},
						hidden: true,
						component: () => import('@/views/user/liveset/water'),
					},
					{
						path: 'see',
						name: 'liveset_see',
						meta: {
							crumb: '直播设置',
							title: '直播设置',
							name: '观看设置',
							parentName: 'mylive.liveset',
						},
						hidden: true,
						component: () => import('@/views/user/liveset/see'),
						children: [
							{
								path: 'surveyRecords',
								name: 'liveset_surveyRecords',
								meta: {
									crumb: '直播设置',
									title: '直播设置',
									name: '观看设置',
									parentName: 'mylive.liveset',
								},
								component: () => import('@/views/user/liveset/see/surveyWatchList'),
							},
							{
								path: 'whiteList',
								name: 'liveset_whiteList',
								meta: {
									crumb: '直播设置',
									title: '直播设置',
									name: '观看设置',
									parentName: 'mylive.liveset',
								},
								component: () => import('@/views/user/liveset/see/whiteList'),
							},
							{
								path: 'whitePhone',
								name: 'liveset_whitePhone',
								meta: {
									crumb: '直播设置',
									title: '直播设置',
									name: '观看设置',
									parentName: 'mylive.liveset',
								},
								component: () => import('@/views/user/liveset/see/whitePhone'),
							},
						],
					},
					{
						path: 'visit',
						name: 'liveset_visit',
						meta: {
							crumb: '直播设置',
							title: '直播设置',
							name: '访问量设置',
							parentName: 'mylive.liveset',
						},
						hidden: true,
						component: () => import('@/views/user/liveset/visit'),
					},
				],
			},
			// 功能设置
			{
				path: 'funcset/:id',
				name: 'mylive.funcset',
				ename: 'funcset/',
				title: '功能设置',
				class: 'icon-pintu',
				meta: {
					crumb: '功能设置',
					title: '功能设置',
					name: '功能设置',
				},
				component: () => import('@/views/user/liveset/func'),
			},
			// 文档演示
			{
				path: 'doc/:id/:docId',
				component: () => import('@/views/user/liveset/func/docLook'),
				name: 'mylive.docLook',
				title: '直播演示',
				hidden: true,
				meta: {
					crumb: '直播演示',
					title: '直播演示',
					parentName: 'mylive.funcset',
				},
			},
			{
				path: 'shop/:id',
				component: () => import('@/views/user/shop'),
				title: '直播商品',
				name: 'mylive.shop',
				ename: 'shop/',
				class: 'icon-daogoushangpin',
				isShoppingGuide: true,
				line: true,
				tagType: 'company',
				meta: {
					crumb: '直播商品',
					title: '直播商品',
				},
			},
			{
				path: 'cooperation/:id',
				component: () => import('@/views/user/cooperation'),
				title: '预约合作',
				name: 'mylive.cooperation',
				ename: 'cooperation/',
				class: 'icon-shenqinghezuo',
				isShoppingGuide: true,
				tagType: 'company',
				meta: {
					crumb: '预约合作',
					title: '预约合作',
				},
			},
			{
				path: 'playbackManage/:id',
				component: () => import('@/views/user/playbackManage'),
				title: '回放管理',
				name: 'mylive.playbackManage',
				ename: 'playbackManage/',
				class: 'icon-meitiku',
				line: true,
				isPay: [0, 2, 3],
				meta: {
					crumb: '回放管理',
					title: '回放管理',
				},
			},
			// 观众管理

			{
				path: 'audienceManage/:id',
				component: () => import('@/views/user/audienceManage'),
				title: '观众管理',
				name: 'mylive.audienceManage',
				ename: 'audienceManage/',
				class: 'icon-guanzhongguanli',
				meta: {
					crumb: '观众管理',
					title: '观众管理',
				},
			},
			// 推广分佣
			{
				path: 'audienceCommission/:id',
				component: () => import('@/views/user/promoter/promoter-detail.vue'),
				title: '推广分佣',
				name: 'mylive.audienceCommission',
				ename: 'audienceCommission/',
				class: 'icon-a-12qiyeguanli',
				meta: {
					crumb: '推广分佣',
					title: '推广分佣',
				},
			},
			// 开播提醒
			{
				path: 'audienceReminder/:id',
				component: () => import('@/views/user/audienceReminder'),
				name: 'mylive.audienceReminder',
				title: '开播提醒',
				ename: 'audienceReminder/',
				hidden: true,
				redirect: {
					name: 'mylive.audienceReminder.subscription',
				},
				meta: {
					crumb: '开播提醒',
					title: '开播提醒',
				},
				children: [
					{
						path: 'subscription',
						name: 'mylive.audienceReminder.subscription',
						meta: {
							crumb: '订阅通知',
							title: '订阅通知',
							parentName: 'mylive.audienceReminder',
						},
						hidden: true,
						component: () => import('@/components/audience/subscribeNotice.vue'),
					},
					{
						path: 'smsNoticeList',
						name: 'mylive.audienceReminder.smsNoticeList',
						meta: {
							crumb: '短信通知',
							title: '短信通知',
							parentName: 'mylive.audienceReminder',
						},
						hidden: true,
						component: () => import('@/components/audience/smsNoticeList.vue'),
					},
				],
			},
			{
				path: 'smsNotice/:id/:taskId?',
				component: () => import('@/components/audience/smsNotice.vue'),
				name: 'mylive.smsNotice',
				title: '短信通知',
				ename: 'smsNotice/',
				hidden: true,
				meta: {
					crumb: '短信通知',
					title: '短信通知',
				},
			},
			// 评论管理
			{
				path: 'commentManage/:id',
				component: () => import('@/views/user/commentManage'),
				title: '评论管理',
				name: 'mylive.commentManage',
				ename: 'commentManage/',
				class: 'icon-pinglunguanli-',
				line: {
					isPay: [0, 1],
				},
				meta: {
					crumb: '评论管理',
					title: '评论管理',
				},
			},
			// 自定义评论
			{
				path: 'customComment/:id',
				component: () => import('@/views/user/comment/custom'),
				title: '自定义评论',
				name: 'mylive.customComment',
				ename: 'customComment/',
				hidden: true,
				meta: {
					crumb: '自定义评论',
					title: '自定义评论',
				},
			},
			// 团队管理
			{
				path: 'teamManage/:id',
				component: () => import('@/views/user/teamManage'),
				name: 'mylive.teamManage',
				title: '团队管理',
				ename: 'teamManage/',
				class: 'icon-tuandui',
				meta: {
					crumb: '团队管理',
					title: '团队管理',
					isMajor: true,
				},
				upgrade: 'activity',
				upgradePayType: 2,
				isMajor: true,
				adminEnable: true,
			},
			// 礼物设置
			{
				path: 'gift/:id',
				component: () => import('@/views/user/gift'),
				title: '礼物设置',
				name: 'mylive.gift',
				ename: 'gift/',
				class: 'icon-liwu',
				meta: {
					crumb: '礼物设置',
					title: '礼物设置',
				},
			},
			// 互动管理
			{
				path: 'interaction/:id',
				component: () => import('@/views/user/interaction'),
				// class:'icon-toupiao',
				title: '互动管理',
				ename: 'interaction/',
				class: 'icon-hudong',
				name: 'mylive.interactionManage',
				meta: {
					crumb: '互动管理',
					title: '互动管理',
					isMajor: true,
				},
				isMajor: true,
				upgrade: 'activity',
				upgradePayType: 2,
				redirect: {
					name: 'mylive.interaction',
				},
				adminEnable: true,
				children: [
					{
						path: 'all/:tab?',
						name: 'mylive.interaction',
						meta: {
							crumb: '互动管理',
							title: '互动管理',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
						component: () => import('@/views/user/interaction/manage'),
					},
					{
						path: 'guess',
						name: 'mylive.guess',
						meta: {
							crumb: '互动管理',
							title: '互动管理',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
						component: () => import('@/views/user/interaction/guess'),
					},
					{
						path: 'look',
						name: 'mylive.look',
						meta: {
							crumb: '互动管理',
							title: '互动管理',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
						component: () => import('@/views/user/interaction/look'),
					},
					// {
					// 	path: '/marketing/watchreward',
					// 	name: 'user.marketing.watchreward',
					// 	component: () => import('@/views/user/marketing/watchreward.vue'),
					// 	title: '观看有奖',
					// 	crumb: '观看有奖',
					// 	hidden: true,
					// 	meta: {
					// 		parentName: 'user.marketing',
					// 		title: '观看有奖',
					// 		crumb: '观看有奖',
					// 	},
					// },
					// {
					// 	path: '/marketing/signin',
					// 	name: 'user.marketing.signin',
					// 	component: () => import('@/views/user/marketing/signin.vue'),
					// 	title: '签到',
					// 	crumb: '签到',
					// 	hidden: true,
					// 	meta: {
					// 		parentName: 'user.marketing',
					// 		title: '签到',
					// 		crumb: '签到',
					// 	},
					// },
					// {
					// 	path: '/marketing/redrain',
					// 	name: 'user.marketing.redrain',
					// 	component: () => import('@/views/user/marketing/redrain.vue'),
					// 	title: '红包雨',
					// 	crumb: '红包雨',
					// 	hidden: true,
					// 	meta: {
					// 		parentName: 'user.marketing',
					// 		title: '红包雨',
					// 		crumb: '红包雨',
					// 	},
					// },
					// {
					// 	path: '/marketing/vote',
					// 	name: 'user.marketing.vote',
					// 	component: () => import('@/views/user/marketing/vote.vue'),
					// 	title: '投票',
					// 	crumb: '投票',
					// 	hidden: true,
					// 	meta: {
					// 		parentName: 'user.marketing',
					// 		title: '投票',
					// 		crumb: '投票',
					// 	},
					// },
					// {
					// 	path: '/marketing/turntable',
					// 	name: 'user.marketing.turntable',
					// 	component: () => import('@/views/user/marketing/turntable.vue'),
					// 	title: '转盘抽奖',
					// 	crumb: '转盘抽奖',
					// 	hidden: true,
					// 	meta: {
					// 		parentName: 'user.marketing',
					// 		title: '转盘抽奖',
					// 		crumb: '转盘抽奖',
					// 	},
					// },
					// {
					// 	path: 'marketing/prizequiz',
					// 	name: 'user.marketing.prizequiz',
					// 	component: () => import('@/views/user/marketing/prizequiz.vue'),
					// 	hidden: true,
					// 	meta: {
					// 		crumb: '互动管理',
					// 		title: '互动管理',
					// 		parentName: 'mylive.interactionManage',
					// 	},
					// },
					{
						path: 'blessingBag',
						name: 'mylive.blessingBag',
						meta: {
							crumb: '互动管理',
							title: '互动管理',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
						component: () => import('@/views/user/interaction/blessingBag'),
					},
					{
						path: 'signIn',
						component: () => import('@/views/user/interaction/signIn'),
						name: 'mylive.signIn',
						title: '签到管理',
						meta: {
							crumb: '互动管理',
							title: '互动管理',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
						redirect: {
							name: 'mylive.signInList',
						},
						children: [
							{
								path: 'list',
								name: 'mylive.signInList',
								meta: {
									crumb: '互动管理',
									title: '互动管理',
									parentName: 'mylive.interactionManage',
								},
								component: () => import('@/views/user/interaction/signIn/list'),
							},
							{
								path: 'detail/:signId',
								name: 'mylive.signInDetail',
								meta: {
									crumb: '互动管理',
									title: '互动管理',
									parentName: 'mylive.interactionManage',
								},
								component: () => import('@/views/user/interaction/signIn/detail'),
							},
						],
					},
					{
						path: 'rainManage',
						name: 'mylive.rainManage',
						meta: {
							crumb: '互动管理',
							title: '互动管理',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
						component: () => import('@/views/user/interaction/rainManage'),
					},
					{
						path: 'rotary',
						name: 'mylive.rotary',
						meta: {
							crumb: '互动管理',
							title: '互动管理',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
						component: () => import('@/views/user/interaction/rotary'),
					},
					{
						path: 'luckManage',
						name: 'mylive.luckManage',
						meta: {
							crumb: '互动管理',
							title: '互动管理',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
						component: () => import('@/views/user/interaction/luckManage'),
					},
					{
						path: 'conditionalLotteryManage',
						name: 'mylive.conditionalLotteryManage',
						meta: {
							crumb: '互动管理',
							title: '互动管理',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
						component: () => import('@/views/user/interaction/conditionalLotteryManage'),
					},
					{
						path: 'messageWall',
						name: 'mylive.messageWall',
						meta: {
							crumb: '互动管理',
							title: '互动管理',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
						component: () => import('@/views/user/interaction/messageWall'),
					},
					{
						path: 'vote',
						name: 'mylive.vote',
						meta: {
							crumb: '互动管理',
							title: '互动管理',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
						component: () => import('@/views/user/interaction/vote'),
					},
					{
						path: 'createrain',
						name: 'mylive.createrain',
						meta: {
							crumb: '互动管理',
							title: '互动管理',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
						component: () => import('@/views/user/interaction/rainManage/createrain'),
					},
					{
						path: 'createGuess',
						name: 'mylive.createGuess',
						meta: {
							crumb: '互动管理',
							title: '互动管理',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
						component: () => import('@/views/user/interaction/guess/createGuess'),
					},
					{
						path: 'createRotary',
						name: 'mylive.createRotary',
						meta: {
							crumb: '互动管理',
							title: '互动管理',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
						component: () => import('@/views/user/interaction/rotary/createrotary'),
					},
					{
						path: 'createlook',
						name: 'mylive.createlook',
						meta: {
							crumb: '互动管理',
							title: '互动管理',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
						component: () => import('@/views/user/interaction/look/createLook'),
					},
					{
						path: 'voteForm',
						component: () => import('@/views/user/interaction/voteForm'),
						name: 'mylive.voteForm',
						meta: {
							crumb: '互动管理',
							title: '互动管理',
							tab: 'vote',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
						title: '新建投票',
					},
					{
						path: 'participantList/:caseId',
						component: () => import('@/views/user/interaction/participantList'),
						name: 'mylive.participantList',
						title: '参与列表',
						meta: {
							crumb: '互动管理',
							title: '互动管理',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
					},
					{
						path: 'rotaryList/:caseId',
						component: () => import('@/views/user/interaction/rotaryList'),
						name: 'mylive.rotaryList',
						title: '参与列表',
						meta: {
							crumb: '互动管理',
							title: '互动管理',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
					},
					{
						path: 'lookList/:caseId',
						component: () => import('@/views/user/interaction/lookList'),
						name: 'mylive.lookList',
						title: '参与列表',
						meta: {
							crumb: '互动管理',
							title: '互动管理',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
					},
					// 单人摇一摇
					{
						path: 'listShake',
						component: () => import('@/views/user/gameList'),
						name: 'mylive.listShake',
						title: '单人摇一摇',
						ename: 'listShake/',
						meta: {
							metaName: 'listShake',
							crumb: '单人摇一摇',
							title: '单人摇一摇',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
					},
					// 疯狂数钱
					{
						path: 'countMoney',
						component: () => import('@/views/user/gameList'),
						name: 'mylive.countMoney',
						title: '疯狂数钱',
						ename: 'countMoney/',
						meta: {
							metaName: 'countMoney',
							crumb: '疯狂数钱',
							title: '疯狂数钱',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
					},
					// 分组摇一摇
					{
						path: 'shakeGroup',
						component: () => import('@/views/user/gameList'),
						name: 'mylive.shakeGroup',
						title: '分组摇一摇',
						ename: 'shakeGroup/',
						meta: {
							metaName: 'shakeGroup',
							crumb: '分组摇一摇',
							title: '分组摇一摇',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
					},
					// 接金币
					{
						path: 'goldCoins',
						component: () => import('@/views/user/gameList'),
						name: 'mylive.goldCoins',
						title: '接金币',
						meta: {
							metaName: 'goldCoins',
							crumb: '接金币',
							title: '接金币',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
					},
					// 套圈圈
					{
						path: 'ferrule',
						component: () => import('@/views/user/gameList'),
						name: 'mylive.ferrule',
						title: '套圈圈',
						meta: {
							metaName: 'ferrule',
							crumb: '套圈圈',
							title: '套圈圈',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
					},
					// 打地鼠
					{
						path: 'whacMole',
						component: () => import('@/views/user/gameList'),
						name: 'mylive.whacMole',
						title: '打地鼠',
						meta: {
							metaName: 'whacMole',
							crumb: '打地鼠',
							title: '打地鼠',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
					},
					{
						path: 'gameSetup/:gameType',
						name: 'mylive.gameSetup',
						meta: {
							crumb: '互动管理',
							title: '互动管理',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
						component: () => import('@/views/user/interaction/gameSetup'),
					},
					{
						path: 'blackList/:gameType',
						name: 'mylive.gameBlackList',
						meta: {
							crumb: '互动管理',
							title: '互动管理',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
						component: () => import('@/views/user/interaction/game/blackList'),
					},
					{
						path: 'WeddingBouquet',
						name: 'mylive.WeddingBouquet',
						title: '抢手捧花',
						meta: {
							crumb: '抢手捧花',
							title: '抢手捧花',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
						component: () => import('@/views/user/interaction/WeddingBouquet'),
					},
					{
						path: 'setScreen',
						name: 'mylive.setScreen',
						meta: {
							crumb: '互动管理',
							title: '互动管理',
							parentName: 'mylive.interactionManage',
						},
						hidden: true,
						component: () => import('@/views/user/interaction/setScreen'),
					},
				],
			},
			// 投票详情
			{
				path: 'voteDetail/:id',
				component: () => import('@/views/user/voteDetail'),
				// class:'icon-toupiao',
				name: 'mylive.voteDetail',
				title: '投票详情',
				ename: 'voteDetail/',
				meta: {
					crumb: '投票详情',
					title: '投票详情',
					parentName: 'mylive.interactionManage',
				},
				hidden: true,
			},
			{
				path: 'voteItemForm/:id',
				component: () => import('@/views/user/voteItemForm'),
				// class:'icon-toupiao',
				name: 'mylive.voteItemForm',
				title: '新建投票项',
				ename: 'voteItemForm/',
				meta: {
					crumb: '新建投票项',
					title: '新建投票项',
					parentName: 'mylive.interactionManage',
				},
				hidden: true,
			},
			{
				path: 'voteItem/:id',
				component: () => import('@/views/user/voteItem'),
				// class:'icon-toupiao',
				name: 'mylive.voteItem',
				title: '投票项详情',
				ename: 'voteItem/',
				meta: {
					crumb: '投票项详情',
					title: '投票项详情',
					parentName: 'mylive.interactionManage',
				},
				hidden: true,
			},
			{
				path: 'listDraw/:id',
				component: () => import('@/views/user/listDraw'),
				name: 'mylive.listDraw',
				title: '名单抽奖',
				ename: 'listDraw/',
				meta: {
					crumb: '名单抽奖',
					title: '名单抽奖',
					parentName: 'mylive.interactionManage',
				},
				hidden: true,
			},
			{
				path: 'listDrawList/:id',
				component: () => import('@/views/user/listDrawList'),
				name: 'mylive.listDrawList',
				title: '参与名单',
				ename: 'listDrawList/',
				meta: {
					crumb: '参与名单',
					title: '参与名单',
					parentName: 'mylive.interactionManage',
				},
				hidden: true,
			},
			{
				path: 'listDrawWin/:id',
				component: () => import('@/views/user/listDrawWin'),
				name: 'mylive.listDrawWin',
				title: '参与名单',
				ename: 'listDrawWin/',
				meta: {
					crumb: '参与名单',
					title: '参与名单',
					parentName: 'mylive.interactionManage',
				},
				hidden: true,
			},

			{
				path: 'winningList/:id',
				component: () => import('@/views/user/winningList'),
				title: '中奖名单',
				name: 'mylive.winningList',
				ename: 'winningList/',
				meta: {
					parentName: 'mylive.interactionManage',
				},
				hidden: true,
			},

			{
				path: 'conditionWinningList/:id',
				component: () => import('@/views/user/conditionWinningList'),
				title: '中奖名单',
				name: 'mylive.conditionWinningList',
				ename: 'conditionWinningList/',
				meta: {
					parentName: 'mylive.interactionManage',
				},
				hidden: true,
			},
			{
				path: 'partakeList/:id',
				component: () => import('@/views/user/partakeList'),
				title: '参与名单',
				name: 'mylive.partakeList',
				ename: 'partakeList/',
				meta: {
					crumb: '参与名单',
					title: '参与名单',
					parentName: 'mylive.interactionManage',
				},
				hidden: true,
			},

			{
				path: 'blessingBagList/:id',
				component: () => import('@/views/user/blessingBagList'),
				title: '参与名单',
				name: 'mylive.blessingBagList',
				ename: 'blessingBagList/',
				meta: {
					crumb: '参与名单',
					title: '参与名单',
					parentName: 'mylive.interactionManage',
				},
				hidden: true,
			},
			{
				path: 'blessingLotteryList/:id',
				component: () => import('@/views/user/blessingLotteryList'),
				title: '中奖名单',
				name: 'mylive.blessingLotteryList',
				ename: 'blessingLotteryList/',
				meta: {
					crumb: '中奖名单',
					title: '中奖名单',
					parentName: 'mylive.interactionManage',
				},
				hidden: true,
			},

			{
				path: 'dataStatistics/:id',
				component: () => import('@/views/user/dataStatistics/index.vue'),
				// class:'icon-toupiao',
				title: '数据统计',
				name: 'mylive.dataStatistics',
				ename: 'dataStatistics/',
				class: 'icon-shujutongji-',
				meta: {
					crumb: '数据统计',
					title: '数据统计',
					isMajor: true,
				},
				isMajor: true,
				upgrade: 'activity',
				upgradePayType: 2,
				adminEnable: true,
			},
			{
				path: 'specialShare/:id',
				component: () => import('@/views/user/SpecialShare'),
				redirect: {
					name: 'mylive.specialShare.wxShare',
				},
				title: '定制分享',
				name: 'mylive.specialShare',
				ename: 'specialShare/',
				class: 'icon-dingzhifenxiang-',
				meta: {
					crumb: '定制分享',
					title: '定制分享',
					isMajor: true,
				},
				isMajor: true,
				upgrade: 'activity',
				upgradePayType: 2,
				adminEnable: true,
				children: [
					{
						path: 'wxShare',
						component: () => import('@/views/user/customShare/wxShare'),
						title: '定制分享',
						name: 'mylive.specialShare.wxShare',
						meta: {
							crumb: '定制分享',
							title: '定制分享',
							parentName: 'mylive.specialShare',
						},
						hidden: true,
					},
					{
						path: 'invite',
						component: () => import('@/views/user/customShare/invite'),
						title: '定制分享',
						name: 'mylive.specialShare.invite',
						meta: {
							crumb: '定制分享',
							title: '定制分享',
							parentName: 'mylive.specialShare',
						},
						hidden: true,
					},
				],
			},
			//
			{
				path: 'reserve/:id',
				component: () => import('@/views/user/reserve'),
				title: '预约执行',
				name: 'mylive.reserve',
				ename: 'reserve/',
				class: 'icon-yuyuezhihang',
				meta: {
					crumb: '预约执行',
					title: '预约执行',
				},
			},
			//榜单详情
			{
				path: 'liveset/rankingList/:id',
				component: () => import('@/views/user/liveset/rankingList'),
				title: '榜单详情',
				name: 'mylive.rankingList',
				ename: 'rankingList/',
				hidden: true,
				meta: {
					crumb: '榜单详情',
					title: '榜单详情',
				},
			},
		],
	},
];
